import {
  Directive,
  ElementRef,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyCop]',
})
export class CurrencyCopDirective implements AfterViewInit {
  private formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  });

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl,
  ) {}

  ngAfterViewInit(): void {
    const value = this.control.control?.value;

    if (value) {
      this.el.nativeElement.value = this.formatter.format(BigInt(value));
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;

    const numericValue = input.value.replace(/\D/g, '');

    this.control.control?.setValue(numericValue || null, { emitEvent: false });

    if (numericValue) {
      input.value = this.formatter.format(BigInt(numericValue));
    } else {
      input.value = '';
    }
  }

  @HostListener('focus')
  onFocus() {
    const value = this.control.control?.value;
    if (value) {
      this.el.nativeElement.value = value;
    }
  }

  @HostListener('blur')
  onBlur() {
    const value = this.control.control?.value;
    if (value) {
      this.el.nativeElement.value = this.formatter.format(BigInt(value));
    }
  }
}
